localStorage.clear()

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en.json'
import zh_HK from './zh-hk.json'
import zh_CN from './zh-cn.json'
import { getCountryByDomain } from '@/common/config'

Vue.use(VueI18n)

const messages = {
  en,
  zh_HK,
  zh_CN
}

const country = getCountryByDomain(window.location.hostname);

const urlParams = new URLSearchParams(window.location.search);
let lang = urlParams.get('lang');
let locale = 'zh_HK';
if (lang && ['en', 'zh_HK', 'zh_CN'].includes(lang)) {
  locale = lang;
} else if (country === 'uk') {
  locale = 'en';
} else if (country === 'hongkong') {
  locale = 'zh_HK';
}

const i18n = new VueI18n({
  locale,
  messages,
})


export default i18n
